import {
    FETCH_IAQ_INSIGHT_DATA_SUCCESS,
    FetchIaqInsightData,
    FetchIaqInsightDataSuccess,
    FetchIaqInsightDataV2,
    InsightActionType,
} from '../actions/insightActions';
import { IaqInsightData, ReportSensorThresholds } from '../models/common';

export type IaqInsightState = {
    locationId: string | undefined;
    sensorReports: { [sensor: string]: IaqInsightData };
    reportId: string;
    includeLogo: boolean;
    serialNumbers: string[];
    thresholds: { [sensor: string]: ReportSensorThresholds };
};

const initialState: IaqInsightState = {
    locationId: undefined,
    sensorReports: {},
    reportId: '',
    includeLogo: false,
    serialNumbers: [],
    thresholds: {},
};

// Used by iaqInsight2 feature: reducer handles both v1 and v2 actions
export default (
    state: IaqInsightState = initialState,
    action: FetchIaqInsightData | FetchIaqInsightDataV2 | FetchIaqInsightDataSuccess
): IaqInsightState => {
    switch (action.type) {
        case InsightActionType.FetchIaqInsightDataInit:
            return {
                ...state,
                includeLogo: action.payload.includeLogo || false,
            };
        // Used by iaqInsight2 feature: v2 action initializes request and sets includeLogo
        case InsightActionType.FetchIaqInsightDataV2Init:
            return {
                ...state,
                includeLogo: action.payload.includeLogo || false,
            };
        case FETCH_IAQ_INSIGHT_DATA_SUCCESS:
            return {
                ...state,
                locationId: action.payload.locationId,
                sensorReports: action.payload.sensorReports,
                reportId: action.payload.reportId,
                includeLogo: action.payload.includeLogo || false,
                // Used by iaqInsight2 feature: ensure serialNumbers is always an array (v2 API may omit it)
                serialNumbers: action.payload.serialNumbers || [],
                thresholds: action.payload.thresholds,
            };
        default:
            return state;
    }
};
